jQuery.fn.CustomSelect = function() {
	const element = jQuery( this ); //element
	const prefix = element.attr( 'data-type' ) + '-' + element.attr( 'data-design' );
	const design = element.attr( 'data-design' );
	const val = element.attr( 'data-value' );
	/**
	 * Function that open and closes the select.
	 */
	element.find( '.' + prefix + '-button' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'is-button-opened' );
		const swapVar = jQuery( this )
			.parent() // Select parent element
			.siblings() // Select siblings of parent
			.find( '.select-dropdown__button' );
		const firstElement = swapVar.eq( 0 );
		if ( jQuery( firstElement ).hasClass( 'is-button-opened' ) ) {
			jQuery( firstElement ).removeClass( 'is-button-opened' );
		}

		element.find( '.' + prefix + '-select-dd-menus' ).toggleClass( 'is-active-dropdown' );
	} );
	/**
	 * Function that runs and set the select value when any option is selected.
	 */
	element.find( '.' + prefix + '-select-item' ).on( 'click', function() {
		element.find( '.' + prefix + '-button' ).toggleClass( 'is-button-opened' );
		element.find( '.' + prefix + '-select-dd-menus' ).toggleClass( 'is-active-dropdown' );
		if ( design === 'multiselect' ) {
			const number = parseInt( element.find( '.' + prefix + '-button' ).find( '.select-dropdown__button-number' ).text() );
			if ( jQuery( this ).hasClass( 'list-active' ) ) {
				element.find( '.' + prefix + '-button' ).find( '.select-dropdown__button-number' ).text( number - 1 );
			} else {
				element.find( '.' + prefix + '-button' ).find( '.select-dropdown__button-number' ).text( number + 1 );
			}
		} else {
			element.find( '.' + prefix + '-button' ).text( jQuery( this ).text() );
			element.find( '.' + prefix + '-select-item' ).removeClass( 'list-active' );
		}
		jQuery( this ).toggleClass( 'list-active' );
	} );
	element.find( '.' + prefix + '-select-item' ).on( 'keypress', function( e ) {
		if ( e.keyCode == 13 ) {
			element.find( '.' + prefix + '-button' ).toggleClass( 'is-button-opened' );
			element.find( '.' + prefix + '-select-dd-menus' ).toggleClass( 'is-active-dropdown' );
			if ( design === 'multiselect' ) {
				const number = parseInt( element.find( '.' + prefix + '-button' ).find( '.select-dropdown__button-number' ).text() );
				if ( jQuery( this ).hasClass( 'list-active' ) ) {
					element.find( '.' + prefix + '-button' ).find( '.select-dropdown__button-number' ).text( number - 1 );
				} else {
					element.find( '.' + prefix + '-button' ).find( '.select-dropdown__button-number' ).text( number + 1 );
				}
			} else {
				element.find( '.' + prefix + '-button' ).text( jQuery( this ).text() );
				element.find( '.' + prefix + '-select-item' ).removeClass( 'list-active' );
			}
			jQuery( this ).toggleClass( 'list-active' );
		}
	} );
	jQuery( document ).mouseup( function( e ) 	{
		// if the target of the click isn't the container nor a descendant of the container
		if ( ! element.is( e.target ) && element.has( e.target ).length === 0 ) {
			element.find( '.' + prefix + '-select-dd-menus' ).removeClass( 'is-active-dropdown' );
		}
	} );
	/**
	 * Function that is used to set the value of select if needed.
	 *
	 * @param {string} value value of the select
	 */
	element.setValue = function( value ) {
		if ( design === 'multiselect' ) {
			const values = value;
			element.find( '.' + prefix + '-button' ).find( '.select-dropdown__button-number' ).text( values.length );
			for ( const key in values ) {
				const el = values[ key ];
				jQuery( '.' + prefix + '-select-item[data-value="' + el + '"]' ).toggleClass( 'list-active' );
			}
		} else {
			element.find( '.' + prefix + '-button' ).text( jQuery( '.' + prefix + '-select-item[data-value="' + value + '"]' ).text() );
			element.find( '.' + prefix + '-select-item' ).removeClass( 'list-active' );
			jQuery( '.' + prefix + '-select-item[data-value="' + value + '"]' ).toggleClass( 'list-active' );
		}
	};

	element.getValue = function() {
		if ( design === 'multiselect' ) {
			const values = [];
			element.find( '.' + prefix + '-select-item' ).each( function() {
				if ( jQuery( this ).hasClass( 'list-active' ) ) {
					values.push( jQuery( this ).attr( 'data-value' ) );
				}
			} );
			return values;
		}
		if ( element.find( '.' + prefix + '-select-item' ).hasClass( 'list-active' ) && typeof element.find( '.' + prefix + '-select-item.list-active' ).attr( 'data-value' ) !== 'undefined' ) {
			return element.find( '.' + prefix + '-select-item.list-active' ).attr( 'data-value' );
		}
		return '';
	};
	if ( '' !== val ) {
		element.setValue( val );
	}
	return element;
};
